<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="物料"><el-input v-model="query.materialCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmTargetCost:list') || isAuth('plm:plmItem:list')" type="primary" size="small" @click="search">查询</el-button>
        <el-button v-if="isAuth('plm:plmTargetCost:save')" type="primary" size="small" @click="open()">维护目标成本</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <el-table-column prop="materialCode" label="物料编码" min-width="120" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('plm:plmTargetCost:save')" class="code-link" @click="open(scope.row)">{{ scope.row.materialCode }}</a>
          <span v-else>{{ scope.row.materialCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="materialName" label="物料名称" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="targetCost" label="目标成本" width="120" header-align="center" align="right" />
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />

    <el-dialog title="维护目标成本" :visible.sync="visible" width="min(520px, calc(100vw - 24px))" :close-on-click-modal="false">
      <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="物料" prop="materialId">
          <el-input :value="form.materialCode" readonly placeholder="点击选择物料">
            <el-button slot="append" @click="materialSelectorVisible = true">选择</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="目标成本" prop="targetCost"><el-input v-model="form.targetCost" placeholder="请输入非负金额，最多 6 位小数" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
    <material-selector :visible.sync="materialSelectorVisible" :multiple="false" @select="onMaterialSelect" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import MaterialSelector from '../../components/MaterialSelector.vue'

export default {
  name: 'PlmTargetCost',
  components: { MaterialSelector },
  data() {
    return {
      query: { materialCode: '' },
      list: [], pageIndex: 1, pageSize: 10, loading: false, visible: false, materialSelectorVisible: false, permCodes: [], form: {},
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },
      rules: {
        materialId: [{ required: true, message: '物料不能为空', trigger: 'change' }],
        targetCost: [
          { required: true, message: '目标成本不能为空', trigger: 'blur' },
          { validator: (rule, value, done) => /^\d+(?:\.\d{1,6})?$/.test(String(value)) ? done() : done(new Error('请输入非负金额，最多 6 位小数')), trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    total() { return this.list.length },
    pageList() { return this.list.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    onMaterialSelect(row) {
      this.form.materialId = row.materialId
      this.form.materialCode = row.materialCode
      this.materialSelectorVisible = false
      this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate('materialId') })
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/plm/item/list', { params: { keyword: this.query.materialCode || '' } }).then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    },
    open(row) {
      this.form = { materialId: row ? row.materialId : '', materialCode: row ? row.materialCode : '', targetCost: row && row.targetCost != null ? String(row.targetCost) : '', remark: row && row.remark != null ? row.remark : '' }
      this.visible = true
      this.$nextTick(() => { this.$refs.dataForm && this.$refs.dataForm.clearValidate() })
      if (row && row.materialId) {
        request.get('/plm/targetCost/byMaterial', { params: { materialId: row.materialId } }).then(res => {
          const data = res.data || {}
          this.form = {
            materialId: data.materialId || row.materialId,
            materialCode: data.materialCode || row.materialCode,
            targetCost: data.targetCost != null ? String(data.targetCost) : '',
            remark: data.remark || ''
          }
        }).catch(() => {})
      }
    },
    save() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        request.post('/plm/targetCost/save', {
          materialId: this.form.materialId, targetCost: this.form.targetCost, remark: this.form.remark
        }).then(() => { this.$message.success('保存成功'); this.visible = false; this.load() }).catch(() => {})
      })
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.code-link { color: #348adb; cursor: pointer; }
</style>
